import { RecurringChargingScheduleModel } from './e-mobility/vehicle-integration/models'
import { WallboxChargingModel } from './wallboxes/models'

export function assertIsString(val: unknown): asserts val is string {
  if (typeof val !== 'string') {
    throw new TypeError('Not a string!')
  }
}

export function assertIsNumber(val: unknown): asserts val is number {
  if (typeof val !== 'number') {
    throw new TypeError('Not a number!')
  }
}

export function assertIsChargingModel(val: unknown): asserts val is WallboxChargingModel {
  //no Content needed
}

export function assertAsRecurringSchedule(val: unknown): val is RecurringChargingScheduleModel {
  return (val as RecurringChargingScheduleModel).enabled !== undefined
}
